// function selectAddFilter (item, index, self) {
// 	return index == self.indexOf(item);
// }
// function deselectFilter (item, action, key) {
// 	return action[key].indexOf(item) < 0;
// }

BatchGeoStore.addReducer(
  "DrawingManager",
  {
    mode: null,
    currentlySelecting: false,
    // NOTE: this is only implemented with the Circle tool! There was no need
    // to implement it for other things per ticket #1256
    shape: {
      // Usually this is the class like Circle
      name: null,
      start: {
        lat: null,
        lng: null,
      },
      end: {
        lat: null,
        lng: null,
      },
    },
  },
  {
    // When DRAWING_MANAGER_SELECTION_STATUS happens we set the state as it was
    // given to us
    DRAWING_MANAGER_SELECTION_STATUS: function (state, action) {
      return Object.assign(state, { currentlySelecting: action.status });
    },
    // When the drawing mode changes (i.e. from hand to circle)
    DRAWING_MANAGER_SET_MODE: function (state, action) {
      return Object.assign(state, {
        mode: action.mode,
        // set currently selecting to false if switching to hand tool
        currentlySelecting:
          action.mode === "hand" ? false : state.currentlySelecting,
      });
    },
    // Save the shape data so that it can be redrawn on page loads for exports
    // NOTE: only supported for circles currently
    DRAWING_MANAGER_SET_SHAPE: function (state, action) {
      return $.extend(true, {}, state, {
        shape: {
          name: action.name,
          start: {
            lat: action.start.lat,
            lng: action.start.lng,
          },
          end: {
            lat: action.end.lat,
            lng: action.end.lng,
          },
        },
      });
    },
  },
);
